/**
 * Wires the SignalR notification feed into the shell platform-notification toaster.
 *
 * Subscribes to the portal SignalR `portalnotificationmethod` hub messages and
 * pushes each into the platform-notification store (see
 * `platform-notification-store.ts`). Mirrors the incident bridge
 * (`incidents-bridge.ts`), minus the initial fetch — there is no notification
 * snapshot endpoint; platform notifications are live-only.
 *
 * Started once from `main.tsx` after authentication + client resolve, alongside
 * the other post-login services (so the hub is connected before messages flow).
 */

import { HubMethod, onPortalMessage } from '@/legacy/signal-r';
import { pushPlatformNotifications } from './platform-notification-store';

let started = false;

export function startPlatformNotifications(): void {
  if (started) return;
  started = true;

  // Live updates over SignalR. The connection negotiates asynchronously, so we
  // subscribe up front; messages only flow once the hub is connected.
  onPortalMessage((msg) => {
    if (msg.methodName !== HubMethod.PortalNotification) return;
    pushPlatformNotifications(msg.result);
  });
}
